import React, { useState } from "react";

function Gallery() {

const images = [
"./Images/2023-02-19.jpg",
"./Images/2023-06-19.jpg",
"./Images/Image1.jpg",
"./Images/Image2.jpg",
"./Images/Image3.jpg",
"./Images/Image4.jpg",
"./Images/images8.jpeg",
"./Images/images12.jpeg",
"./Images/images13.jpeg",
"./Images/images15.jpeg",
"./Images/images16.jpeg",
"./Images/images17.jpeg",
];

const [selectedIndex, setSelectedIndex] = useState(null);
const [showAll, setShowAll] = useState(false);

const visibleImages = showAll ? images : images.slice(0, 6);

const nextImage = (e) => {
e.stopPropagation();
setSelectedIndex((prev) => (prev + 1) % images.length);
};

const prevImage = (e) => {
e.stopPropagation();
setSelectedIndex((prev) =>
prev === 0 ? images.length - 1 : prev - 1
);
};

return (

<section className="gallery" id="gallery">

<h2>Our Pool Gallery</h2>

<div className="gallery-grid">
{visibleImages.map((img, index) => (
<div className="gallery-item" key={index}>
<img
src={img}
alt="pool"
onClick={() => setSelectedIndex(index)}
/>
</div>
))}
</div>

{/* More Images Button */}
{!showAll && (

<div style={{ textAlign: "center", marginBottom: "30px" }}>
<button
className="btn"
onClick={() => setShowAll(true)}
>
View More Images
</button>
</div>
)}

{/* Lightbox */}
{selectedIndex !== null && (

<div
className="lightbox"
onClick={() => setSelectedIndex(null)}
>

<button className="prev-btn" onClick={prevImage}>❮</button>

<img
src={images[selectedIndex]}
alt="preview"
onClick={(e) => e.stopPropagation()}
/>

<button className="next-btn" onClick={nextImage}>❯</button>

</div>
)}

</section>
);
}

export default Gallery;
